import { createApp, defineAsyncComponent } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import { menuCartPersistence } from '@/stores/menuCartStore'
import router from './router'
import './design/tokens.css'
import './index.css'
import './design/ui.css'
import './design/bridge.css'
import PrimeVue from 'primevue/config';
import Wind from '@/presets/wind';
import Column from 'primevue/column'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import Toast from 'primevue/toast'
import ToastService from 'primevue/toastservice';
import Dialog from 'primevue/dialog'
import ConfirmDialog from 'primevue/confirmdialog'
import ConfirmationService from 'primevue/confirmationservice';

// Theme (light/dark) and brand are applied per route by App.vue (src/lib/uiTheme.js).

const app = createApp(App)
const pinia = createPinia()
pinia.use(menuCartPersistence)
app.use(pinia)
app.use(router)
app.use(PrimeVue, {
    unstyled: true,
    pt: Wind                            //apply preset        
});
app.use(ToastService);
app.use(ConfirmationService);
// Dashboard-only components load the first time a screen uses them, so the
// restaurant's public site does not download them (17 October 2026 review).
// Column stays eager: DataTable recognises its columns by their component type.
app.component('Dialog',Dialog)
app.component('DataTable', defineAsyncComponent(() => import('primevue/datatable')))
app.component('Column', Column)
app.component('Button', Button)
app.component('Listbox', defineAsyncComponent(() => import('primevue/listbox')))
app.component('Toolbar', defineAsyncComponent(() => import('primevue/toolbar')))
app.component('Card', defineAsyncComponent(() => import('primevue/card')))
app.component('Dropdown', defineAsyncComponent(() => import('primevue/dropdown')))
app.component('InputText',InputText)
app.component('TabMenu', defineAsyncComponent(() => import('primevue/tabmenu')))
app.component('Menubar', defineAsyncComponent(() => import('primevue/menubar')))
app.component('Avatar', defineAsyncComponent(() => import('primevue/avatar')))
app.component('Toast',Toast)
app.component('ConfirmDialog',ConfirmDialog)
app.mount('#app')
